import React from "react";

const EmptyData = (props) => {
  let { message = "We don't have any records yet." } = props;

  return <div className={props.className}>{message}</div>;
};

export default EmptyData;
